import { StandardEvents } from '@shopify/events';

// Use the inherited theme's authoritative cart event; never infer success from a click.
const count = document.querySelector('[data-cc-cart-count]');
let revision = 0;
function render(value) {
  if (count && Number.isInteger(value) && value >= 0) count.textContent = String(value);
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const current = ++revision;
  event.promise?.then(({ cart, detail }) => {
    if (current === revision) render(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => { /* The inherited form displays cart errors. */ });
});
window.addEventListener('pageshow', async event => {
  if (!event.persisted || !count) return;
  const current = ++revision;
  try {
    const response = await fetch(count.dataset.cartUrl + '.js', { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    if (current === revision) render(cart.item_count);
  } catch { /* Keep server-rendered count when unavailable. */ }
});
